// import React from 'react';
import { useTranslation } from '../../TranslationContext';

const PartnersSlider = () => {
  const { t } = useTranslation();

  // Styles intégrés avec keyframes
  const styles = `
    @keyframes scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(calc(-100% - 2rem));
      }
    }

    .partner-scroll {
      animation: scroll 25s linear infinite;
    }

    .partner-scroll:hover {
      animation-play-state: paused;
    }
    
    .partner-card {
      transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
    
    .partner-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(82, 103, 142, 0.15);
    }
  `;

  // Simulons des logos de partenaires
  const partners = [
    { id: 1, name: 'Partenaire 1', logo: '/api/placeholder/150/50' },
    { id: 2, name: 'Partanaire 2', logo: '/api/placeholder/150/50' },
    { id: 3, name: 'Partenaire 3', logo: '/api/placeholder/150/50' },
    { id: 4, name: 'Partenaire', logo: '/api/placeholder/150/50' },
    { id: 5, name: 'Paix', logo: '/api/placeholder/150/50' },
    { id: 6, name: 'jOIE', logo: '/api/placeholder/150/50' },
    { id: 7, name: 'Sante', logo: '/api/placeholder/150/50' },
    { id: 8, name: 'sucess', logo: '/api/placeholder/150/50' },
  ];

  return (
    <>
      {/* Injection des styles */}
      <style>{styles}</style>
      
      <section className="bg-slate-50 dark:bg-slate-900 py-16 relative overflow-hidden">
        {/* Éléments décoratifs */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-rose-200 dark:bg-rose-800 opacity-20 rounded-full -translate-x-16 -translate-y-16 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-blue-200 dark:bg-blue-800 opacity-20 rounded-full translate-x-24 translate-y-24 blur-3xl"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-slate-800 dark:text-white">
              {t('they_trust_us')} <span className="text-rose-500 dark:text-rose-400">{t('trust')}</span>
            </h2>
            <p className="mt-4 text-lg text-slate-600 dark:text-slate-300">
              {t('join_our_trusted_network')}
            </p>
          </div>
          
          {/* Container pour l'animation */}
          <div className="relative overflow-hidden py-6">
            {/* Gradient de fondu à gauche */}
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-slate-50 dark:from-slate-900 to-transparent z-10"></div>
            
            {/* Gradient de fondu à droite */}
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-slate-50 dark:from-slate-900 to-transparent z-10"></div>
            
            {/* Conteneur du défilement */}
            <div className="flex space-x-8 partner-scroll">
              {/* Premier groupe de logos */}
              <div className="flex space-x-8 items-center">
                {partners.map((partner) => (
                  <div
                    key={partner.id}
                    className="partner-card flex items-center justify-center h-24 w-48 bg-white dark:bg-slate-800 rounded-lg shadow-sm p-4 grayscale hover:grayscale-0 opacity-80 hover:opacity-100"
                  >
                    <img
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      className="max-h-16 w-auto object-contain"
                    />
                  </div>
                ))}
              </div>
              
              {/* Deuxième groupe de logos (clone pour un défilement infini) */}
              <div className="flex space-x-8 items-center">
                {partners.map((partner) => (
                  <div
                    key={`clone-${partner.id}`}
                    className="partner-card flex items-center justify-center h-24 w-48 bg-white dark:bg-slate-800 rounded-lg shadow-sm p-4 grayscale hover:grayscale-0 opacity-80 hover:opacity-100"
                  >
                    <img
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      className="max-h-16 w-auto object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="text-center mt-10">
            <button className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-md text-white bg-gradient-to-r from-rose-500 to-rose-600 hover:from-rose-600 hover:to-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 transition-all duration-300">
              {t('become_a_partner')}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default PartnersSlider;